import { mobilePageViewActions } from '../../services';

export const mobilePageViewReducer = ( state = {showPage:"other"}, action ) =>{
    switch(action.type){
      case mobilePageViewActions.SHOWSEARCH:
        return {...state, ["showPage"]:"search"};
      case mobilePageViewActions.SHOWCART:
        return {...state, ["showPage"]:"cart"};
      case mobilePageViewActions.SHOWOTHER:
        return {...state, ["showPage"]:"other"};
      case mobilePageViewActions.SHOWHOMEPAGE:
        return {...state, ["showPage"]:"homePage"};
      case mobilePageViewActions.SHOWSELECTOR:
        return {...state, ["showPage"]:"selector"}
      default:
        return state;
    }
  }